// The payer-facing pages: what a customer of a customer reaches from a link (/p/<token>,
// /d/<token>, /hi/<slug>). Whoever is on one isn't our user, so these pages are always light,
// show the merchant's contact when they crash, and treat a 401 or 403 as a rejected link token
// rather than our session. hi is spelled out so /history-style routes can't slip in.
const PAYER_PAGE = /^\/(hi|[pd])\/[^/]+/;

export const isPayerPage = (path) => PAYER_PAGE.test(path || '');
